/* House of TML — interactive layer for tml-* sections. Author: Play N Tek */
(function () {
  'use strict';

  document.documentElement.classList.add('tml-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  var revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealObserver.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

  function initReveal(root) {
    var items = (root || document).querySelectorAll('[data-tml-reveal]:not(.is-visible)');
    items.forEach(function (el) {
      if (!revealObserver || reduceMotion) {
        el.classList.add('is-visible');
      } else {
        revealObserver.observe(el);
      }
    });
  }

  /* ---------- Scroller arrows ---------- */
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-tml-scroller]').forEach(function (wrap) {
      if (wrap.dataset.tmlReady) return;
      wrap.dataset.tmlReady = '1';
      var track = wrap.querySelector('.tml-scroller');
      var prev = wrap.querySelector('[data-tml-prev]');
      var next = wrap.querySelector('[data-tml-next]');
      if (!track) return;

      function step() {
        var child = track.firstElementChild;
        return child ? child.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* Optional autoplay (testimonials) */
      var autoplay = parseInt(wrap.dataset.tmlAutoplay || '0', 10);
      if (autoplay > 0 && !reduceMotion) {
        var timer;
        var start = function () {
          stop();
          timer = setInterval(function () {
            var max = track.scrollWidth - track.clientWidth - 2;
            if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
            else track.scrollBy({ left: step(), behavior: 'smooth' });
          }, autoplay * 1000);
        };
        var stop = function () { if (timer) clearInterval(timer); };
        wrap.addEventListener('mouseenter', stop);
        wrap.addEventListener('mouseleave', start);
        wrap.addEventListener('focusin', stop);
        wrap.addEventListener('touchstart', stop, { passive: true });
        start();
      }
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-tml-tabs]').forEach(function (wrap) {
      if (wrap.dataset.tmlReady) return;
      wrap.dataset.tmlReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));

      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          var on = p.id === tab.getAttribute('aria-controls');
          p.hidden = !on;
          if (on) {
            p.querySelectorAll('[data-tml-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
            var scroller = p.querySelector('.tml-scroller');
            if (scroller) scroller.dispatchEvent(new Event('scroll'));
          }
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight') idx = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') idx = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') idx = 0;
          if (e.key === 'End') idx = tabs.length - 1;
          if (idx !== null) { e.preventDefault(); activate(tabs[idx], true); }
        });
      });
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    if (window.TML && window.TML.backToTop === false) return;
    if (document.querySelector('.tml-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tml-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 13V3M3.5 7.5 8 3l4.5 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    document.body.appendChild(btn);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-shown', window.scrollY > window.innerHeight * 1.2);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Sticky add to cart (product pages) ---------- */
  function initStickyAtc(root) {
    var bar = (root || document).querySelector('[data-tml-sticky-atc]');
    if (!bar || bar.dataset.tmlReady) return;
    bar.dataset.tmlReady = '1';

    var findBuy = function () {
      return document.querySelector(
        'main product-form-component add-to-cart-component button, main product-form-component button[name="add"], main .product-form button[name="add"]'
      );
    };
    var target = findBuy();
    var form = target ? target.closest('form, product-form-component, .product-form') : null;
    var watchEl = form || target;
    var action = bar.querySelector('[data-tml-sticky-action]');

    function sync() {
      var t = findBuy();
      if (!t || !action) return;
      var unavailable = t.disabled || t.getAttribute('aria-disabled') === 'true';
      action.textContent = unavailable ? action.dataset.soldText : action.dataset.addText;
      action.classList.toggle('is-disabled', unavailable);
    }

    if (action) {
      action.addEventListener('click', function () {
        var t = findBuy();
        if (t && !t.disabled) {
          t.click();
        } else if (watchEl) {
          watchEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }

    if (watchEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', show);
          document.body.classList.toggle('tml-has-sticky-atc', show);
          if (show) sync();
        });
      }).observe(watchEl);
    }
    document.addEventListener('variant:update', sync);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) setTimeout(sync, 150);
    });
  }


  /* ---------- Hero slider ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-tml-hero]').forEach(function (hero) {
      if (hero.dataset.tmlReady) return;
      hero.dataset.tmlReady = '1';
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.tml-hero__slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-tml-hero-go]'));
      var counter = hero.querySelector('[data-tml-hero-current]');
      var pauseBtn = hero.querySelector('[data-tml-hero-pause]');
      var delay = parseInt(hero.dataset.autoplay || '0', 10) * 1000;
      var current = 0;
      var timer = null;
      var started = 0;
      var remaining = delay;
      var userPaused = false;
      if (slides.length < 2) return;
      if (!delay || reduceMotion) hero.classList.add('is-static');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function go(index) {
        index = (index + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          s.querySelectorAll('a, button').forEach(function (el) {
            if (el.classList.contains('tml-hero__media')) return;
            if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        });
        dots.forEach(function (d, i) {
          d.classList.remove('is-active');
          d.classList.toggle('is-done', i < index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
          void d.offsetWidth; /* restart progress animation */
          if (i === index) d.classList.add('is-active');
        });
        if (counter) counter.textContent = pad(index + 1);
        current = index;
        schedule(delay);
      }

      function schedule(ms) {
        clearTimeout(timer);
        if (!delay || reduceMotion || userPaused) return;
        remaining = ms;
        started = Date.now();
        if (hero.classList.contains('is-paused')) return;
        timer = setTimeout(function () { go(current + 1); }, ms);
      }
      function hold() {
        if (hero.classList.contains('is-paused')) return;
        hero.classList.add('is-paused');
        clearTimeout(timer);
        remaining = Math.max(400, remaining - (Date.now() - started));
      }
      function release() {
        if (userPaused) return;
        hero.classList.remove('is-paused');
        schedule(remaining);
      }

      /* hide the "inactive" slides' links from keyboard users on load */
      go(0);

      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.tmlHeroGo, 10)); }); });
      var prev = hero.querySelector('[data-tml-hero-prev]');
      var next = hero.querySelector('[data-tml-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        if (hero.classList.contains('is-static')) { hero.classList.remove('is-static'); if (!delay) delay = 7000; userPaused = false; go(current); pauseBtn.setAttribute('aria-label', 'Pause slideshow'); return; }
        userPaused = !userPaused;
        hero.classList.toggle('is-user-paused', userPaused);
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        if (userPaused) { hero.classList.add('is-paused'); clearTimeout(timer); }
        else { hero.classList.remove('is-paused'); go(current); }
      });

      hero.addEventListener('mouseenter', hold);
      hero.addEventListener('mouseleave', release);
      hero.addEventListener('focusin', hold);
      hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) release(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) hold(); else release(); });
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') go(current + 1);
        if (e.key === 'ArrowLeft') go(current - 1);
      });

      /* swipe */
      var x0 = null, y0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; hold(); }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
        x0 = null;
        hero.classList.remove('is-paused');
        schedule(delay);
      }, { passive: true });

      /* theme editor: jump to the selected slide */
      hero.addEventListener('shopify:block:select', function (e) {
        var idx = slides.indexOf(e.target.closest('.tml-hero__slide'));
        if (idx > -1) { userPaused = true; hero.classList.add('is-paused', 'is-user-paused'); go(idx); clearTimeout(timer); }
      });
    });
  }

  function initAll(root) {
    initHero(root);
    initReveal(root);
    initScrollers(root);
    initTabs(root);
    initStickyAtc(root);
  }

  function boot() {
    if (window.TML) window.TML.ready = true;
    document.documentElement.classList.add('tml-js');
    initAll(document);
    initBackToTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[role="tabpanel"]');
    if (panel) {
      var tab = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (tab) tab.click();
    }
  });
})();
